import React from "react";
import DateUtility from "./dateUtility";
import { BPMemberRole } from "./bpMemberRole";
import { shiftIcons } from "./shiftIcons";
/**
 * Fired after any change to a byttevagt or a swap offer. The two halves of the byttevagt loop live
 * in separate cards on Min side, and an action in one can resolve something listed in the other -
 * accepting a swap lapses competing offers and can lapse the accepter's own outgoing ones - so each
 * listens and re-fetches rather than going stale.
 */
export const SWAP_CHANGED_EVENT = "bp:swap-changed";
/** "lør. 17. okt · 18:30–21:45", the way the byttevagt screens name a shift. */
export const shiftWhen = (shift) => {
    if (!shift)
        return "Vagten findes ikke længere";
    const start = DateUtility.parse(shift.dtStart);
    return `${DateUtility.rowDay(start)} · ${DateUtility.rowInterval(start, DateUtility.parse(shift.dtEnd))}`;
};
/**
 * "fre. 19. feb. kl. 18:00–22:30": the same, inside a sentence, as the swap confirmations name
 * the shifts they trade. Empty when the shift is gone.
 */
export const shiftInSentence = (shift) => {
    if (!shift)
        return "";
    // On a phone the sentence wraps, and a line break after the dash splits the time in two:
    // "kl." stays with its time (no-break space) and the time stays whole (word joiners).
    const start = DateUtility.parse(shift.dtStart);
    const interval = DateUtility.rowInterval(start, DateUtility.parse(shift.dtEnd)).replace("–", "⁠–⁠");
    return `${DateUtility.rowDay(start)} kl. ${interval}`;
};
/** The role in the words of the screens: Operatør and Kiosk. */
export const roleName = (role) => role === BPMemberRole.operator ? "Operatør" : "Kiosk";
/** "Birgit Lunds", "Hans'": a name that ends in s, x or z takes only the apostrophe. */
export const possessive = (name) => /[sxz]$/i.test(name) ? `${name}'` : `${name}s`;
/**
 * What the question of Udbyd vagt says about the shift: "lør. 17. okt · 18:30–21:45" and, under it,
 * "Operatør · Druk, Italiensk for begyndere" - the role and the films.
 */
export const udbydSummary = (shift, role) => {
    var _a;
    const start = DateUtility.parse(shift.dtStart);
    const end = DateUtility.parse(shift.dtEnd);
    const films = ((_a = shift.events) !== null && _a !== void 0 ? _a : []).map((evt) => { var _a; return (_a = evt.eventContent) === null || _a === void 0 ? void 0 : _a.title; }).filter(Boolean);
    return {
        when: `${DateUtility.rowDay(start)} · ${DateUtility.rowInterval(start, end)}`,
        detail: [role === BPMemberRole.operator ? "Operatør" : "Kiosk", films.join(", ")].filter(Boolean).join(" · ")
    };
};
const roleIcon = (role) => React.createElement("i", { className: role === BPMemberRole.operator ? "fas fa-film" : "fas fa-cash-register", title: role });
/**
 * A shift line - status dot, role icon and the "[WW] ma 07.10.26 17:00-22:00" stamp every other
 * screen uses, linking to the shift page.
 *
 * Pass linked={false} where the line sits inside something else that is meant to be tapped, such as
 * the checkbox rows in the "Byt med mig" pick list: a link filling the row would send a thumb aimed
 * at the tick box off to the shift page instead, losing every choice made so far.
 */
export const ShiftLine = ({ shift, role, linked = true }) => {
    if (!shift)
        return React.createElement("span", { className: "text-muted" }, "Vagten findes ikke l\u00E6ngere");
    const stamp = DateUtility.stringify(DateUtility.parse(shift.dtStart), DateUtility.parse(shift.dtEnd));
    return (React.createElement("span", null,
        shiftIcons(shift),
        roleIcon(role),
        linked ? React.createElement("a", { href: `/vagtinfo?shiftId=${shift.id}` }, stamp) : stamp));
};
